export enum SHEET_TRANSITION {
  BOTTOM,
  RIGHT,
  LEFT,
  TOP,
}
